module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAqUlEQVR42p1ROw5CMQyrxAq3gZGvmLhJ8x4NSR+Z33k6s3MBJAZuwcoBACOWQoeCl8q2XKepA1JKAwrRfNATBbnhBIfuPgHRsxyJ5UAcJ9T3Q5zg0L9CuAmmKwA6/ExEfSs2LgXQBD8TMTPGKAXMbAT/twbWyz9vKG8JTdmWgtyboJssUPoHjPHi0q2f/NruupWrxVb2U4RIdVkdajjO3k2L6pAXmRPL+QHrenMgJaItnwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/search_1x.png
// module id = 2319
// module chunks = 0